import { getAsIfState } from './asIfView';

/**
 * F-0709: the as-if UI (the banner, its words and its API) is one chunk, fetched only by a tab that holds a
 * view. The boot of such a tab awaits it before the first render (`index.tsx`), so the banner is on the
 * first frame and no gate says a missing key; a tab with no view never loads it
 * (`check-first-screen-chunks.mjs` holds the entry to that).
 */
let loaded: typeof import('./AsIfBanner') | null = null;

/** The banner once the as-if UI is loaded, so a tab that waited for it draws it in its first commit. */
export function loadedAsIfBanner(): (typeof import('./AsIfBanner'))['AsIfBanner'] | null {
  return loaded?.AsIfBanner ?? null;
}

export async function loadAsIfUi(): Promise<typeof import('./AsIfBanner')> {
  loaded = await import('./AsIfBanner');
  await endAViewStartedBeforeItsLimit();
  return loaded;
}

/**
 * I-2497: a view held without what its target holds beyond the starter (`limited`) was started before
 * the web kept it; it cannot draw a control the target holds and the view may not use as disabled
 * with why, so it ends with that reason: revoked, then said by the banner, and started again it is
 * whole.
 */
async function endAViewStartedBeforeItsLimit(): Promise<void> {
  const view = getAsIfState().view;
  if (!view || view.limited) return;
  const [{ asIfApi }, { endAsIfView }] = await Promise.all([
    import('@/services/AsIfApi'),
    import('./asIfEnding'),
  ]);
  // Revoked with the view's own token while it is still held; a failed revoke still lets it go here.
  await asIfApi.stop(view.workAreaId).catch(() => undefined);
  endAsIfView('refused', undefined, 'startedBefore');
}
